<template>
  <div class="text-center">
    <img src="@/assets/images/icons/adwords_protected.svg" alt="adwords protected">
    <h3 class="title mt-2 mb-2">Google Ads account connected</h3>
    <p class="sub-title">Now, let's get to know each other</p>

    <form ref="form" @submit.prevent>
      <label class="mt-0">
        <span>Full name</span>
        <input v-model="full_name.value" type="text" name="full_name" @keypress="limitInputToNumbersAndLetters">
      </label>

      <label>
        <span>Business name</span>
        <input v-model="business_name.value" type="text" name="business_name" @keypress="limitInputToNumbersAndLetters">
      </label>

      <label class="select-wrapper">
        <span>Industry</span>
        <select v-model="industry.value" name="industry">
          <option v-for="rule of INDUSTRY_RULES" :value="rule.id ? rule.name : ''" v-text="rule.name" :key="rule.id" />
        </select>
      </label>

    </form>

    <step-navigation-buttons @next="handleNext" @skip="handleSkip" skip/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { sendReportDataLayer, getExternalId, getCookie } from "@/utils"
import INDUSTRY_RULES from "@/consts/INDUSTRY_RULES";
import StepNavigationButtons from "@/components/global/StepNavigationButtons";

export default {
  name: "MoreInformation",
  components: {
    StepNavigationButtons,
  },
  data: () => ({
    full_name: {
      value: '',
    },
    business_name: {
      value: '',

    },
    industry: {
      value: '',
    },
    inputs: ['full_name', 'business_name', 'industry'],
    regex: /[)(}{|\\,;?><~!@#$%^&*_=+\]\[]+/i,
  }),
  setup() {
    return { INDUSTRY_RULES };
  },
  computed: {
    ...mapGetters(['get_account', 'get_domains'])
  },
  methods: {
    ...mapActions(['SAVE_DETAILS']),

    async handleForm() {
      let formHasValue = false;

      let obj = {};
      this.inputs.forEach(input => {
        if ( this[input].value )
          formHasValue = true;
        obj[input] = this[input].value;
      });

      if ( formHasValue )
        return await this.SAVE_DETAILS(obj);
    },

    async handleNext() {
      await this.handleForm();
      this.handleSkip();
    },

    handleSkip() {
      this.sendEvent();
      this.$router.push({ name: 'Report 1' });
    },

    sendEvent() {
      const account = this.get_account || {};
      const last30_spend = this.get_domains
        ? this.get_domains.reduce( (acc, domain) => {
          return ('SpendLast30Days' in domain) ? acc + domain. SpendLast30Days : acc;
        }, 0)
        : 'Not return from the server yet';

      sendReportDataLayer({
        report_step: 4,
        report_step_name: 'details',
        industry: this.industry,
        last30_spend,
        ad_account_currency: account.AccountCurrency,
        event_id: 'id:' + Date.now() + Math.random(),
        external_id: getExternalId(),
        fbp : getCookie('_fbp'),
        event_source_url: window.location.href,
      });
    },

    limitInputToNumbersAndLetters(e) {
      if ( this.regex.test(e.key) ) e.returnValue = false;
    }
  },
  watch: {
    'full_name.value': {
      handler(val) {
        this.full_name.value = val.replace(this.regex, '');
      }
    },
    'business_name.value': {
      handler(val) {
        this.business_name.value = val.replace(this.regex, '');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/responsive";

img {
  width: 172px;

  @include mobile {
    width: 150px;
  }
}
p.sub-title {
  @include mobile {
    font-size: 20px;
  }
}
</style>